module.exports = __webpack_public_path__ + "static/media/straightNormalLine.f57fe802.svg";